import axios from 'axios';
import { config } from '@/helpers/variables';
import { API_URL } from '@/helpers/variables';

export const ratingService = {
  async postRating(data: object) {
    const API_POST_URL = `${API_URL}satellite/rating/`;
    config;

    axios
      .post(API_POST_URL, data, config)
      .then((res) => {
        // console.log('RESPONSE ==== : ', res);
      })
      .catch((err) => {
        console.log('ERROR: ====', err);
      });
  },
};
